/*
 * Author Amit Ranjan Mohanty<amit.ranjanmohanty@vodafone.com>
 * Base is the default environment for production.
 * Add everything here and override value in other files if needed.
 */

import type { SharedEnvironment } from "@ucchub/ui";
import { sharedBaseEnv } from "@ucchub/ui";

type FeatureFlagsEnv = "development" | "production" | "staging";

export default function baseEnv(
  baseApi: string,
  legacyBaseApi: string,
  featureFlagsEnv: FeatureFlagsEnv
) {
  const sharedEnv = sharedBaseEnv(baseApi);

  return {
    portalUrl: "https://hub.ucc-dev.vodafone.com",
    supportSiteUrl: "https://support.hub.ucc-dev.vodafone.com",
    baseApi: "https://api.hub.ucc-dev.vodafone.com",
    privacyPolicyLink:
      "https://www.vodafone.com/business/privacy-policy#cookie-policy",
    legacyBaseApi,
    api: {
      auth: `${baseApi}/authentication`,
      users: `${baseApi}/user`,
      roles: `${baseApi}/role`,
      userSchema: `${baseApi}/user/validation-schema/create-user`,
      roleSchema: `${baseApi}/role/validation-schema/create-role`,
      navbar: `${baseApi}/role/nav-bar`,
      manageAccessTabs: `${baseApi}/role/permissions/ATTR-17fffb6c-fb6c-ffb6cdd30.-.432`,
      organisation: `${baseApi}/organisation/v1/organisation`,
      organisationInfo: `${baseApi}/cloud-numbers/v1/organisation`,
      products: `${baseApi}/organisation/v1/product`,
      cloudNumberFeatureFlags: `https://hub.ucc.vodafone.com/feature_flags/cloud_numbers/${featureFlagsEnv}.json`,
      useCase: `${baseApi}/external-integrations/v1/solutions-hub/use-cases`,
      numberType: `${baseApi}/external-integrations/v1/solutions-hub/number-types`,
      serviceType: `${baseApi}/external-integrations/v1/solutions-hub/service-types`,
      regulatoryRequirements: `${baseApi}/external-integrations/v1/solutions-hub/regulatory-requirements`,
      customer: `${baseApi}/organisation/v1/organisation`,
      accessType: `${baseApi}/external-integrations/v1/solutions-hub/access-types`,
      permissions: `${baseApi}/role/v1/get-user-permissions`,
    },
    sharedApi: sharedEnv.api,
    isProduction: (() => false)(),
    isDevelopment: (() => true)(),
    isStaging: (() => false)(),
  } satisfies SharedEnvironment;
}

export type Environment = ReturnType<typeof baseEnv>;
